import React, { useState, useEffect } from "react";

import Link from "next/link";
import { useRouter } from "next/router";

import { ProductData } from "data/product/products";
import { Button } from "studio-design-system";

import { useAnalytics } from "~/analytics/useAnalytics";
import { getRecommendations } from "~/api/checkoutApi";
import { ClassSectionItem } from "~/components/browse";
import { ClassCardSkeleton } from "~/components/collections/ClassCard";
import { ClassCard } from "~/components/collections/ClassCard/ClassCard";
import { AddToCartSuccess } from "~/components/common/Modals/AddToCartSuccess";
import { OverlayModal } from "~/components/common/OverlayModal";
import { useCart } from "~/hooks/cart/useCart";
import { useIsMobileScreen } from "~/hooks/ui/useIsMobileScreen";

import * as styles from "./RecommendedSection.css";

export const RecommendedSection = ({
  userId,
  useAllPurchases,
  products,
  sectionTitle,
}: {
  userId: string | undefined;
  useAllPurchases: boolean;
  products: ProductData[];
  sectionTitle?: string;
}) => {
  const [recommendedProducts, setRecommendedProducts] = useState({
    products: [] as ProductData[],
    isLoading: true,
  });

  const isMobileScreen = useIsMobileScreen();
  const router = useRouter();
  const { trackAmplitudeEvent } = useAnalytics();

  const [showAddToCartModal, setShowAddToCartModal] = useState({
    productData: null as ProductData | null,
    show: false,
  });

  const setShowAddToCartModalWithProduct = (productData: ProductData) => {
    setShowAddToCartModal({ productData, show: true });
  };

  useEffect(() => {
    // if (userId) {
    (async () => {
      const result = await getRecommendations(products, [], useAllPurchases, userId);
      setRecommendedProducts({
        products: result,
        isLoading: false,
      });
    })();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return (
    <>
      <div className={styles.classesWrap}>
        {sectionTitle ? <h2 className={styles.classesWrapHeading}>{sectionTitle}</h2> : null}
        <div className={styles.classesContainer}>
          {recommendedProducts.products.map((productData, index) => (
            <ClassSectionItem
              isHomepage={false}
              singleColumnGrid={isMobileScreen}
              productData={productData}
              key={index}
              trackAmplitudeEvent={trackAmplitudeEvent}
              setShowAddToCartModal={setShowAddToCartModalWithProduct}
              isFourColumnsGrid={!isMobileScreen}
              //alreadyInCart={isInCart(productData)}
            />
            // <ClassCard
            //   key={`product_${index}`}
            //   productData={productData}
            //   alreadyInCart={isInCart(productData)}
            //   showAddToCart={true}
            //   singleColumnGrid={false}
            //   isFourColumnsGrid={true}
            //   shouldOpenInNewTab={true}
            // />
          ))}
          {recommendedProducts.isLoading ? <ClassCardSkeleton /> : null}
        </div>

        <div className={styles.ctaContainer}>
          <Button 
            variant="secondary" 
            onClick={() => window.open("/browse", "_blank")}
          >
            Browse all classes
          </Button>
        </div>

        <OverlayModal
          isOpen={showAddToCartModal.show}
          contentClass={styles.overlayModal}
          onClose={() => {
            setShowAddToCartModal({
              productData: null,
              show: false,
            });
          }}
        >
          <>
            {showAddToCartModal.productData && (
              <AddToCartSuccess
                product={showAddToCartModal.productData}
                closePopup={() =>
                  setShowAddToCartModal({
                    productData: null,
                    show: false,
                  })
                }
              />
            )}
          </>
        </OverlayModal>
      </div>
    </>
  );
};
